import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
export var getCommonFieldValidators = function getCommonFieldValidators() {
  return {
    fieldName: function fieldName(value) {
      return typeof value === 'string';
    },
    isVisible: function isVisible(value) {
      return typeof value === 'boolean';
    },
    description: validateDescription,
    isReadOnly: function isReadOnly(value, _ref) {
      var isReadOnlyBySystem = _ref.isReadOnlyBySystem;
      return typeof value === 'boolean' && (value || !value && !isReadOnlyBySystem);
    },
    isRequired: function isRequired(value, _ref2) {
      var isRequiredBySystem = _ref2.isRequiredBySystem;
      return typeof value === 'boolean' && (value || !value && !isRequiredBySystem);
    }
  };
};
export var validateDescription = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(value) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(typeof value !== 'string')) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", false);
        case 2:
          return _context.abrupt("return", true);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function validateDescription(_x) {
    return _ref3.apply(this, arguments);
  };
}();